import useBiggestWinsCardVariant from '@/hooks/theme/variants/useBiggestWinsCardVariant';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import dynamic from 'next/dynamic';
import { BiggestWinsProps } from './props';

const GameCardBiggestWinsV1 = dynamic(() => import('./V1'), {
  ssr: true,
});
const GameCardBiggestWinsV3 = dynamic(() => import('./V3'), {
  ssr: true,
});

export default function GameCardBiggestWins({
  bet,
  isLoading,
  isLuckiest,
}: BiggestWinsProps) {
  const { version } = useBiggestWinsCardVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.BiggestWinsCardV1?.toString():
      return (
        <GameCardBiggestWinsV1
          bet={bet}
          isLoading={isLoading}
          isLuckiest={isLuckiest}
        />
      );
    case SettingLayoutComponentId.BiggestWinsCardV2?.toString():
      return (
        <GameCardBiggestWinsV3
          bet={bet}
          isLoading={isLoading}
          isLuckiest={isLuckiest}
        />
      );
    default:
      return null;
  }
}
